// extracted by mini-css-extract-plugin
export default {"case-tabs":"styles_case-tabs__nKwJm","case-tab":"styles_case-tab__Z3tMD","case-tab-helper":"styles_case-tab-helper__AsTYS","case-tab-agent":"styles_case-tab-agent__L7piu"};